import { NavigationModel } from '@app/shared/models';
import { environment } from '@env/environment';

export const mainNavigationConfig: NavigationModel[] = [
    {
        title: 'home-page',
        path: 'home',
        icon: 'pi pi-home',
        role: 'ROLE_FEATURE_STORE_MANAGER',
        enabled: true,
    },
    {
        title: 'catalog',
        path: 'catalog',
        icon: 'pi pi-star',
        enabled: environment.catalog,
    },
    {
        title: 'orders',
        path: 'orders',
        icon: 'pi pi-shopping-cart',
        enabled: true,
        children: [
            {
                title: 'orders-list',
                path: 'orders/list',
                enabled: true,
            },
            {
                title: 'orders-new-classic',
                path: 'orders/new/classic',
                enabled: true,
            },
            {
                title: 'orders-new-catalog',
                path: 'orders/new/catalog',
                enabled: true,
            },
            {
                title: 'orders-new-special',
                path: 'orders/new/special',
                enabled: true,
            },
        ],
    },
    {
        title: 'invoices',
        path: 'invoices',
        icon: 'pi pi-wallet',
        role: 'ROLE_FEATURE_CHAIN_STORE_MANAGER',
        children: [],
        enabled: environment.demo.enabled === true ? false : true,
    },
    {
        title: 'reports',
        path: 'reports',
        icon: 'pi pi-folder',
        role: 'ROLE_FEATURE_REPORTS',
        children: [],
        enabled: environment.demo.enabled === true ? false : true,
    },
    {
        title: 'products',
        path: 'products',
        icon: 'pi pi-circle-off',
        needsChildren: true,
        enabled: environment.catalog,
        children: [
            {
                title: 'products',
                path: 'products/items',
                icon: 'pi pi-circle-off',
                role: 'ROLE_FEATURE_PRODUCT_MANAGEMENT',
                children: [],
                enabled: environment.catalog,
            },
            {
                title: 'product-categories',
                path: 'products/categories',
                icon: 'pi pi-circle-off',
                role: 'ROLE_FEATURE_PRODUCT_CATEGORIES',
                children: [],
                enabled: environment.catalog,
            },
        ],
    },
    {
        title: 'stores',
        path: 'facilities',
        icon: 'pi pi-sitemap',
        role: 'ROLE_FEATURE_STORE_MANAGER',
        enabled: true,
        children: [
            {
                title: 'facilities-chains',
                path: 'facilities/chains',
                role: 'ROLE_FEATURE_CHAIN_STORE_MANAGER',
                icon: 'pi pi-sitemap',
                enabled: true,
            },
            {
                title: 'facilities-stores',
                path: 'facilities/stores',
                role: 'ROLE_FEATURE_STORE_MANAGER',
                icon: 'pi pi-sitemap',
                enabled: true,
            },
        ],
    },
    {
        title: 'users',
        path: 'users',
        icon: 'pi pi-users',
        role: 'ROLE_FEATURE_STORE_MANAGER',
        enabled: true,
    },
    {
        title: 'web',
        path: 'web',
        icon: 'pi pi-cog',
        role: 'ROLE_FEATURE_ADMIN',
        enabled: environment.demo.enabled === true ? false : true,
        children: [
            {
                title: 'web',
                path: 'web/general',
                role: 'ROLE_FEATURE_ADMIN',
                enabled: environment.demo.enabled === true ? false : true,
            },
            {
                title: 'web-stores',
                path: 'web/stores',
                role: 'ROLE_FEATURE_ADMIN',
                enabled: environment.demo.enabled === true ? false : true,
            },
        ],
    },
    {
        title: 'client',
        path: 'client',
        icon: 'pi pi-user',
        enabled: environment.clientSection,
        children: [
            {
                title: 'display-materials',
                path: 'client/display-materials',
                icon: 'pi pi-circle-off',
                children: [],
                enabled: environment.clientSection,
            },
            {
                title: 'price-list',
                path: 'client/price-list',
                role: 'ROLE_FEATURE_STORE_MANAGER',
                icon: 'pi pi-circle-off',
                children: [],
                enabled: environment.clientSection,
            },
            {
                title: 'alloy-prices',
                path: 'client/alloy-prices',
                icon: 'pi pi-circle-off',
                enabled: environment.clientSection,
                children: [],
            },
            {
                title: 'downloads',
                path: 'client/downloads',
                icon: 'pi pi-circle-off',
                enabled: environment.clientSection,
                children: [],
            },
        ],
    },
    {
        title: 'import-csv',
        path: environment.demo.enabled ? ['import-csv/welcome-page'] : ['import-csv'],
        icon: 'pi pi-file',
        role: 'ROLE_FEATURE_ADMIN',
        enabled: true,
        children: [
            {
                title: 'display-materials',
                path: 'import-csv/display-materials',
                icon: 'pi pi-circle-off',
                children: [],
                role: 'ROLE_FEATURE_ADMIN',
                enabled: environment.demo.enabled === true ? false : true,
            },
            {
                title: 'price-list',
                path: 'import-csv/price-list',
                icon: 'pi pi-circle-off',
                children: [],
                role: 'ROLE_FEATURE_ADMIN',
                enabled: environment.demo.enabled === true ? false : true,
            },
            {
                title: 'downloads',
                path: 'import-csv/downloads',
                icon: 'pi pi-circle-off',
                children: [],
                role: 'ROLE_FEATURE_ADMIN',
                enabled: environment.demo.enabled === true ? false : true,
            },
            {
                title: 'welcome-page',
                path: 'import-csv/welcome-page',
                icon: environment.demo.enabled === true ? 'pi pi-file' : 'pi pi-circle-off',
                children: [],
                role: 'ROLE_FEATURE_ADMIN',
                enabled: true,
            },
            {
                title: 'products-classic',
                path: 'import-csv/products-classic',
                icon: 'pi pi-circle-off',
                children: [],
                role: 'ROLE_FEATURE_ADMIN',
                enabled: environment.demo.enabled === true ? false : true,
            },
            {
                title: 'assets',
                path: 'assets',
                icon: 'pi pi-circle-off',
                children: [],
                role: 'ROLE_FEATURE_ADMIN',
                enabled: environment.demo.enabled === true ? false : true,
            },
        ],
    },
    {
        title: 'exchange-rates',
        path: 'exchange-rates',
        icon: 'pi pi-euro',
        role: 'ROLE_FEATURE_EXCHANGE_RATES',
        enabled: true,
    },
    {
        title: 'metal_purchases',
        path: 'metal-order',
        icon: 'pi pi-box',
        role: 'ROLE_FEATURE_CHAIN_STORE_MANAGER',
        enabled: environment.metalOrders.enabled,
        children: [
            {
                title: 'metal-order-dashboard',
                path: 'metal-order',
                role: 'ROLE_FEATURE_CHAIN_STORE_MANAGER',
                enabled: environment.metalOrders.enabled,
            },
            {
                title: 'metal-price-modifier',
                path: 'metal-order/price-modifier',
                role: 'ROLE_FEATURE_ADMIN',
                enabled: environment.metalOrders.enabled,
            },
        ],
    },
];
